import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Header, Message } from 'react-frontier';
import { useBreadcrumbs } from '../Hooks';
import PromoterForm from '../components/PromoterForm';
import API from '../API';

var PromoterFormView = ()=>{
	var { promoter_id } = useParams<{ promoter_id: string }>();
	var { setTitle } = useBreadcrumbs();
	var pid = parseInt(promoter_id);
	var [prospectId, setProspectId] = useState<number>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		setTitle(`Formulario Promotor #${promoter_id}`);
		setProspectId(null);
		setLoadError(null);
		if(!pid || isNaN(pid)) return;
		API.getPromoterInfo(pid).then(res=>{
			if(res.error) return setLoadError(res.message);
			setProspectId(res.data.prospect_id);
		}).catch(()=>{
			setLoadError('Hubo un error cargando el promotor. (LCL-PRMFRM-1)');
		});
	}, [promoter_id]);

	if(!pid || isNaN(pid)){
		return <Message type='error' header='ID inválido' style={{ maxWidth: 600, margin: '20px auto' }}>
			El identificador del promotor no es válido.
		</Message>
	}

	if(loadError) return <Message type='error' header='Error' style={{ maxWidth: 600, margin: '20px auto' }}>{loadError}</Message>;
	if(!prospectId) return <div style={{ paddingTop: 40 }}><Header loading text='Cargando...' /></div>;

	return <div style={{ maxWidth: 900, margin: 'auto', padding: '20px 0' }}>
		<PromoterForm prospect_id={prospectId} mode='admin' />
	</div>
}

export default PromoterFormView;
